<template>
    <div>
        index2:{{ time }}

    </div>
</template>
<script setup >
import {ref} from "vue"
const time=new Date()
</script>